import { Component, Input } from '@angular/core';
import { ICellConfig, BaseCellComponent } from '../base-cell/base-cell.component';

export interface IAttachmentData {
  iconId: string;
  href: string;
  thumbnailSrc?: string;
  isInternal: boolean;
  isImage?: boolean;
  altText?: string;
}

export interface IAttachmentCellConfig extends ICellConfig {
  attachments: IAttachmentData[];
}

@Component({
  selector: 'table-cell-attachments',
  styleUrls: ['../base-cell/base-cell.component.scss'],
  template: `
    <div #ref class="attachments-container">
      @if (imageAttachments.length) {
        <div class="attachments-images">
          @for (attachment of imageAttachments; track attachment.href) {
            <a
              [href]="attachment.href"
              [appDownloadLink]="attachment.isInternal"
              [attr.aria-label]="attachment.altText"
              rel="noreferrer noopener"
              target="_blank"
            >
              @if (failedImageHrefs.has(attachment.href)) {
                <svg>
                  <use [attr.xlink:href]="'#' + attachment.iconId"></use>
                </svg>
              } @else {
                <img
                  class="attachment-thumbnail"
                  [src]="attachment.thumbnailSrc"
                  [attr.alt]="attachment.altText"
                  (error)="onImageError(attachment.href)"
                />
              }
              <i aria-hidden="true"></i>
            </a>
          }
        </div>
      }
      @if (fileAttachments.length) {
        <div class="attachments-files">
          @for (attachment of fileAttachments; track attachment.href) {
            <a
              [href]="attachment.href"
              [appDownloadLink]="attachment.isInternal"
              [attr.aria-label]="attachment.altText"
              rel="noreferrer noopener"
              target="_blank"
              class="pe-2"
            >
              <svg>
                <use [attr.xlink:href]="'#' + attachment.iconId"></use>
              </svg>
              <i aria-hidden="true"></i>
            </a>
          }
        </div>
      }
    </div>
  `,
  standalone: false,
})
export class AttachmentsCellComponent extends BaseCellComponent {
  @Input() public config: IAttachmentCellConfig;

  public readonly failedImageHrefs: Set<string> = new Set<string>();

  public get imageAttachments(): IAttachmentData[] {
    return (this.config?.attachments ?? []).filter((attachment: IAttachmentData): boolean => Boolean(attachment.isImage));
  }

  public get fileAttachments(): IAttachmentData[] {
    return (this.config?.attachments ?? []).filter((attachment: IAttachmentData): boolean => !attachment.isImage);
  }

  public onImageError(href: string): void {
    this.failedImageHrefs.add(href);
  }
}
